module.exports = __webpack_public_path__ + "c0f338dbbeaa302b61aae21ab9ce69cc.svg";